import {
  ActivityIndicator,
  Image,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  TouchableOpacity,
  Keyboard,
  Platform,
  useWindowDimensions,
} from 'react-native';
import { WEB_MAX_CONTENT_WIDTH } from '../theme/webLayoutWidths';
import { AppAlert } from '../services/AppAlert';
import { KeyboardStickyView } from 'react-native-keyboard-controller';
import KeyboardAwareFormScroll from '../components/Reusables/KeyboardAwareFormScroll';
import TestLocationBanner from '../components/Reusables/TestLocationBanner';
import SaleCustomerBanner from '../components/sale/SaleCustomerBanner';
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';
import Button from '../components/Reusables/Button';
import { ModalContext } from '../Context/modalContext';
import { useDispatch } from 'react-redux';
import {
  addToCart,
  addToCartOrderData,
  addToCartQuantity,
  CartItem,
  ClearCart,
  clearCartOrderData,
  DecreaseCart,
  getTotals,
  removeCartItem,
  updateCartItemSellingPrice,
} from '../redux/cartSlice';
import useAuth from '../hooks/useAuth';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { ExtrasContext } from '../Context/ExtrasContext';
// import Indicator from '../components/Reusables/Indicator';
import AnimatedLottieView from 'lottie-react-native';
import ErrorContext from '../Context/ErrorContext';
import NameModal from '../components/Modals/NameModal';
import PriceEditModal from '../components/Modals/PriceEditModal';
import FontAwesome6 from '@react-native-vector-icons/fontawesome6/static';
import { useAppSelector } from '../redux/helper';
import {
  selectCartItems,
  selectCartOrderData,
  selectUpdatingCartItems,
} from '../redux/cartSlice';
import { clearOrderDetails, setOrderDetails } from '../redux/orderDetailsSlice';
import { resetCheckoutPaymentIntent } from '../redux/checkoutSlice';
import { exitEditingCurrentOrder } from '../redux/cartActions';
import { s, fs, iconSize, v, borderWidth, formatMoney } from '../utils/libs';
import {
  updateProductsAfterCheckout,
  selectProductDocs,
} from '../redux/productSlice';
import { setUpdatingCartitems } from '../redux/cartSlice';
import { useFocusEffect } from '@react-navigation/native';
import { AppSnackbar } from '../services/AppSnackbar';
import {
  formatNumberDecimal,
  replaceCurrencyString,
  isNumericEffectivelyZero,
  roundMoney,
  roundToNumericPrecision,
} from '../utils/libs';
import { getApiMessage } from '../utils/apiError';
import { orderCustomerContactFromDoc } from '../utils/orderCustomerContact';
import DeviceInfo, { isTablet } from 'react-native-device-info';
import { upsertOrderDoc } from '../redux/OrdersSlice';
import ReviewService from '../services/ReviewService';
import { useNavigation as useNavigationContext } from '../Context/NavigationContext';
import { useTheme, GTFonts, LatoFonts, useLayoutSize } from '../theme';
import {
  selectQuantityButtons,
  selectUseGestureQuantity,
} from '../redux/SettingsSlice';
import {
  selectProductSort,
  ProductSortOption,
} from '../redux/productSortSlice';
import { getEffectiveQuantity } from '../utils/variantHelpers';
import { appendServiceMeta, isStockTracked } from '../utils/productKind';
import QuantityControls from '../components/Reusables/QuantityControls';
import {
  shouldUseWebLayout,
  shouldUseWidthConstraint,
} from '../utils/layoutUtils';
import {
  isEmployeeAdminRole,
  canEmployeeCheckout,
  isEmployeeWaiterRole,
} from '../utils/roles';
import appAnalytics from '../services/appAnalytics';
import { buildAppAnalyticsContext } from '../services/appAnalyticsContext';
import { getProductDisplayName } from '../utils/productDisplayName';

// Define the OrderItem interface
export interface OrderItem {
  bp_product_id: string;
  bp_variant_id?: string;
  bp_order_price: number;
  bp_order_quantity: number;
  bp_order_mass: number | null;
  bp_order_price_type: string;
  bp_selling_price_changed?: boolean;
}

type CheckoutNavigationPayload = {
  order: any[];
  orderID: string;
  Payment_Information: any;
  ReceiptID: string;
};

// Add validation function for order items
const validateOrderItem = (item: any): item is OrderItem => {
  // Basic validations
  if (
    !item?.bp_product_id?.trim() ||
    typeof item.bp_order_price !== 'number' ||
    item.bp_order_price < 0
  ) {
    return false;
  }

  if (!item?.bp_order_price_type?.trim()) {
    return false;
  }

  if (
    item?.bp_variant_id !== undefined &&
    (typeof item.bp_variant_id !== 'string' || !item.bp_variant_id.trim())
  ) {
    return false;
  }

  // Quantity validation based on price type
  const isUnitType = item.bp_order_price_type === 'unit';
  const hasValidQuantity = isUnitType
    ? item.bp_order_quantity === undefined ||
      item.bp_order_quantity === null ||
      typeof item.bp_order_quantity === 'number'
    : typeof item.bp_order_quantity === 'number' && item.bp_order_quantity > 0;

  if (!hasValidQuantity) {
    return false;
  }

  // Mass validation (null or valid number)
  if (
    item.bp_order_mass !== null &&
    (typeof item.bp_order_mass !== 'number' || item.bp_order_mass < 0)
  ) {
    return false;
  }

  return true;
};

// Add function to safely map cart items to order items
const mapCartItemToOrderItem = (cartItem: CartItem): OrderItem | null => {
  try {
    // Validate required fields are present and valid before mapping
    if (!cartItem.productID || cartItem.productID.toString().trim() === '') {
      console.error('Missing or invalid productID in cart item:', cartItem);
      return null;
    }

    if (typeof cartItem.price !== 'number' || cartItem.price < 0) {
      console.error('Missing or invalid price in cart item:', cartItem);
      return null;
    }

    if (cartItem.price_type !== 'unit') {
      if (typeof cartItem.Quantity !== 'number' || cartItem.Quantity <= 0) {
        console.error('Missing or invalid quantity in cart item:', cartItem);
        return null;
      }
    }

    if (!cartItem.price_type || cartItem.price_type.toString().trim() === '') {
      console.error('Missing or invalid price_type in cart item:', cartItem);
      return null;
    }

    // For unit type items, mass is required and must be valid
    let bp_order_mass: number | null = null;
    if (cartItem.price_type === 'unit') {
      if (typeof cartItem.mass !== 'number' || cartItem.mass < 0) {
        console.error('Missing or invalid mass for unit type item:', cartItem);
        return null;
      }
      bp_order_mass = cartItem.mass;
    }
    const orderItem: OrderItem = {
      bp_product_id: cartItem.productID.toString(),
      ...(cartItem.variantId
        ? { bp_variant_id: cartItem.variantId.toString() }
        : {}),
      bp_order_price: roundMoney(
        cartItem.price *
          (cartItem.price_type === 'unit'
            ? (cartItem.mass ?? 0)
            : (cartItem.Quantity ?? 0)),
      ),
      bp_order_quantity: cartItem.Quantity ?? 0,
      bp_order_mass:
        bp_order_mass === null ? null : roundToNumericPrecision(bp_order_mass),
      bp_order_price_type: cartItem.price_type.toString(),
      bp_selling_price_changed: cartItem.bp_selling_price_changed ?? false,
    };
    console.log('orderItem', orderItem);
    console.log('validateOrderItem', validateOrderItem(orderItem));
    return validateOrderItem(orderItem) ? orderItem : null;
  } catch (error) {
    console.error('Error mapping cart item to order item:', error);
    return null;
  }
};

const sameCartIdentity = (
  left: { productID?: string; variantId?: string | null },
  right: { productID?: string; variantId?: string | null },
): boolean =>
  String(left?.productID ?? '') === String(right?.productID ?? '') &&
  (left?.variantId ?? null) === (right?.variantId ?? null);

const getCartIdentityKey = (item: {
  productID?: string | null;
  variantId?: string | null;
}): string => `${item?.productID ?? ''}::${item?.variantId ?? ''}`;

const sameOrderLineIdentity = (orderLine: any, cartItem: CartItem): boolean => {
  const info = orderLine?.bp_product_information;
  return (
    String(info?._id ?? '') === String(cartItem?.productID ?? '') &&
    (info?.bp_variant_id ?? orderLine?.bp_variant_id ?? null) ===
      (cartItem?.variantId ?? null)
  );
};

const getOrderLineAvailableStock = (
  orderLine: any,
  cartItem: CartItem,
): number => {
  const info = orderLine?.bp_product_information;
  const fallbackStock = Number(info?.bp_product_quantity ?? 0);
  if (!cartItem?.variantId) return fallbackStock;

  const variantId = cartItem.variantId;
  const variants = Array.isArray(info?.bp_product_variants)
    ? info.bp_product_variants
    : [];
  const matchedVariant = variants.find(
    (variant: any) => String(variant?._id ?? '') === String(variantId),
  );
  if (matchedVariant) {
    return Number(matchedVariant?.bp_variant_quantity ?? 0);
  }
  return Number(info?.bp_variant_quantity ?? fallbackStock);
};

const Cart: React.FC<{ navigation: any }> = ({ navigation }) => {
  const { theme } = useTheme();
  const { width, height } = useLayoutSize();
  const useWebLayout = shouldUseWebLayout(width, height);
  const useWidthConstraint = shouldUseWidthConstraint(width, height);
  const styles = useMemo(
    () => createStyles(theme, { useWebLayout, useWidthConstraint }),
    [theme, useWebLayout, useWidthConstraint],
  );
  // Using AppSnackbar instead of useToast
  const settings = useAppSelector(state => state.settings.settings);
  const [isCancelling, setIsCancelling] = useState(false);
  const isTablet = DeviceInfo.isTablet();
  const { clearOrderDetailsData } = useNavigationContext();
  const {
    visibleName,
    input,
    setInput,
    setVisibleName,
    assignedStaffId,
    setAssignedStaffId,
    selectedCustomerId,
    setSelectedCustomerId,
  } = useContext(ModalContext);
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPatching, setIsPatching] = useState(false);
  const [isSellingPriceEditVisible, setIsSellingPriceEditVisible] =
    useState(false);
  const [sellingPriceEditItem, setSellingPriceEditItem] =
    useState<CartItem | null>(null);
  const updatingCartitems = useAppSelector(selectUpdatingCartItems);
  const { setReceipt, networkAvailableGlobal } = useContext(ExtrasContext);
  const [massValues, setMassValues] = useState<{ [key: string]: string }>({});
  const { auth, setAuth } = useAuth();
  const axiosprivate = useAxiosPrivate();
  const employeedata = useAppSelector(
    state => state.auth.inApp.account.employeeInfo,
  );
  const owner = useAppSelector(s => s.backofficeOwnerAuth);
  const isAdmin = isEmployeeAdminRole(employeedata?.bp_employee_role);
  const canCheckout = canEmployeeCheckout(employeedata?.bp_employee_role);
  const [isloading, setIsLoading] = useState(false);
  const {
    handleError,
    resetSnackMessage,
    setQuantityInputError,
    quantityInputError,
  } = useContext(ErrorContext);
  const orderDetails = useAppSelector(state => state?.orderdetails.order);
  const qtyButtons = useAppSelector(selectQuantityButtons);
  const useGestureQuantity = useAppSelector(selectUseGestureQuantity);
  const pendingPreviousOrder = useAppSelector(
    state => state?.orders.pending.previousDocs,
  );
  const cartItems = useAppSelector(selectCartItems);
  const cartOrderData = useAppSelector(selectCartOrderData);
  const products = useAppSelector(selectProductDocs);
  const sortOption = useAppSelector(selectProductSort);
  const dispatch = useDispatch();
  const cart = useAppSelector(state => state.cart);
  const currency = useAppSelector(
    state =>
      state.location.currentLocation?.bp_location_settings
        ?.bp_location_currency || 'KES',
  );
  const currentLocation = useAppSelector(
    state => state.location.currentLocation,
  );
  const isStaffAssignmentEnabled = useMemo(() => {
    if (isEmployeeWaiterRole(employeedata?.bp_employee_role)) return false;
    const fromLocation =
      currentLocation?.bp_location_settings
        ?.bp_location_allow_staff_order_assignment;
    if (typeof fromLocation === 'boolean') return fromLocation;
    return Boolean(settings?.allow_staff_order_assignment);
  }, [
    employeedata?.bp_employee_role,
    currentLocation?.bp_location_settings
      ?.bp_location_allow_staff_order_assignment,
    settings?.allow_staff_order_assignment,
  ]);
  const currencyTextLower = useMemo(
    () => replaceCurrencyString('ksh', currency),
    [currency],
  );
  const currencyTextCapital = useMemo(
    () => replaceCurrencyString('Ksh', currency),
    [currency],
  );

  const originalOrderProductIdSet = useMemo(
    () => new Set(pendingPreviousOrder?.map(d => getCartIdentityKey(d)) ?? []),
    [pendingPreviousOrder],
  );

  const displayedCartItems = useMemo(() => {
    if (!cartItems || cartItems.length === 0) return cartItems;
    const byId = new Map(products.map(p => [p._id, p]));
    return [...cartItems].sort((a, b) => {
      const pa = byId.get(a.productID);
      const pb = byId.get(b.productID);
      let cmp = 0;
      switch (sortOption as ProductSortOption) {
        case 'price_desc':
          cmp =
            (pb?.bp_product_selling_price ?? b.price ?? 0) -
            (pa?.bp_product_selling_price ?? a.price ?? 0);
          break;
        case 'recent':
          cmp = String(b.productID).localeCompare(String(a.productID));
          break;
        case 'in_stock':
          cmp = getEffectiveQuantity(pb) - getEffectiveQuantity(pa);
          break;
        default:
          cmp = String(pa?.bp_product_name ?? a.itemname ?? '').localeCompare(
            String(pb?.bp_product_name ?? b.itemname ?? ''),
          );
          break;
      }
      if (cmp !== 0) return cmp;
      return String(a.itemname ?? '').localeCompare(String(b.itemname ?? ''));
    });
  }, [cartItems, products, sortOption]);

  useFocusEffect(
    React.useCallback(() => {
      if (cartItems.length > 0) {
        updateMassValues();
        dispatch(getTotals());
      }
      return () => {
        // resetSnackMessage();
      };
    }, [cartItems, updatingCartitems]),
  );
  useEffect(() => {
    if (cartItems.length > 0) {
      cartItems.forEach(item => {
        if (item.price_type === 'unit') {
          if (updatingCartitems) {
            console.log(
              'updatingCartitems',
              item.mass,
              item.bp_order_paid_mass,
            );
            if (
              item.mass &&
              item.mass < (Number(item.bp_order_paid_mass) ?? 0)
            ) {
              setTextInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: true,
              }));
            } else {
              setTextInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: false,
              }));
            }
          } else {
            if (item.mass && item.mass <= (item?.quantity ?? 0)) {
              setTextInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: false,
              }));
            }
          }
        } else {
          if (updatingCartitems) {
            if (
              item.Quantity &&
              item.Quantity < (Number(item.bp_order_paid_quantity) ?? 0)
            ) {
              setQuantityInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: true,
              }));
            } else {
              setQuantityInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: false,
              }));
            }
          } else {
            if (item.Quantity && item.Quantity <= (item?.quantity ?? 0)) {
              setQuantityInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: false,
              }));
            }
          }
        }
      });
    }
  }, [cartItems]);
  const Clear = () => {
    try {
      dispatch(setUpdatingCartitems(false));
      navigation.navigate('ProductsScreen');
      dispatch(clearCartOrderData());
      dispatch(ClearCart());
      dispatch(resetCheckoutPaymentIntent());
      setAssignedStaffId(null);
      setInput('');
      setSelectedCustomerId(null);
      setTextInputError({});
      setQuantityInputError({});
      clearOrderDetailsData();
    } catch (error) {
      console.log('ClearCartError', error);
    }
  };
  const { textInputError, setTextInputError } = useContext(ErrorContext);
  const updateMassValues = () => {
    if (cartItems.length > 0) {
      const newMassValues: { [key: string]: string } = {};
      let hasChanges = false;

      cartItems.forEach(item => {
        if (item.price_type === 'unit') {
          const key = getCartIdentityKey(item);
          const massString =
            item.mass == null
              ? undefined
              : String(roundToNumericPrecision(item.mass));
          if (massValues[key] !== massString) {
            newMassValues[key] = massString ?? '';
            hasChanges = true;
          }
        }
      });

      if (hasChanges) {
        setMassValues(prev => ({ ...prev, ...newMassValues }));
      }
    }
  };
  const handleClearCart = () => {
    setIsCancelling(true);
    // Let React render the loading state first, then execute clearing
    requestAnimationFrame(() => {
      handleError('The order has been cancelled', 'success', true);
      Clear();
      //original
      // if (orderDetails?.orderType.toLowerCase() === "pending") {
      //   dispatch(clearOrderDetails());
      // }
      if (orderDetails?.orderType.toLowerCase() !== 'completed') {
        dispatch(clearOrderDetails());
      }
      setIsCancelling(false);
    });
  };

  // Quantity color helpers
  type ColorKey = keyof typeof theme.colors;
  const resolveColor = (key: string | undefined, fallback: ColorKey) => {
    const k = (key || '') as ColorKey;
    return theme.colors[k] ?? theme.colors[fallback];
  };
  const resolveLightForMain = (
    mainKey: string | undefined,
    fallback: ColorKey,
  ) => {
    const main = (mainKey || '') as ColorKey;
    const lightKey = (main + 'Light') as ColorKey;
    if ((theme.colors as any)[lightKey]) return (theme.colors as any)[lightKey];
    return theme.colors[fallback];
  };

  // Validation function for quantity errors
  const validateQuantityError = useCallback(
    (quantity: number, productId: string, item: CartItem) => {
      const errorKey = getCartIdentityKey(item);
      const cartItem = cart?.cartItems?.find(existingCartItem =>
        sameCartIdentity(existingCartItem, {
          productID: productId,
          variantId: item.variantId,
        }),
      );

      if (
        updatingCartitems &&
        quantity < (Number(cartItem?.bp_order_paid_quantity) ?? 0)
      ) {
        setQuantityInputError(prevErrors => ({
          ...prevErrors,
          [errorKey]: true,
        }));
      } else if (quantity <= (cartItem?.quantity ?? 0)) {
        setQuantityInputError(prevErrors => ({
          ...prevErrors,
          [errorKey]: false,
        }));
      }
    },
    [
      updatingCartitems,
      cart?.cartItems,
      setTextInputError,
      setQuantityInputError,
    ],
  );

  const onAdd = (item: CartItem) => {
    if (item.price_type === 'item') {
      const newQuantity = (item.Quantity ?? 0) + 1;
      validateQuantityError(newQuantity, item.productID, item);
    }
    // Vibration.vibrate(10);
    dispatch(addToCart(item));
    dispatch(getTotals());
  };

  const handleSubproductQuantity = (product: any) => {
    console.log('handleSubproductQuantity', product);
    dispatch(DecreaseCart(product));
    dispatch(getTotals());
  };

  const Cancel = useCallback(
    (title: string, message: string) => {
      AppAlert.alert(title, message, [
        {
          text: 'Cancel',
          onPress: () => {
            return;
          },
          style: 'cancel',
        },
        { text: 'Continue', onPress: () => handleClearCart() },
      ]);
    },
    [dispatch],
  );
  const RemoveItem = useCallback(
    (item: CartItem, onDone?: () => void) => {
      const runRemove = () => {
        handleSubproductQuantity(item);
        onDone?.();
      };
      if (settings?.showLastProductRemovalPopup !== false) {
        AppAlert.alert(
          'Remove Item ?',
          'Are you sure you want to remove this item?',
          [
            {
              text: 'Cancel',
              onPress: () => {
                return;
              },
              style: 'cancel',
            },
            {
              text: 'Continue',
              onPress: runRemove,
            },
          ],
        );
      } else {
        runRemove();
      }
    },
    [dispatch, settings?.showLastProductRemovalPopup],
  );

  const onSub = useCallback(
    (item: any) => {
      // Vibration.vibrate(10);
      const cartItems = cart?.cartItems;
      const cartOrderData = cart?.cartOrderData;
      const cartProduct = cartItems[0];
      console.log(cartProduct, 'cartProduct');
      if (
        cartOrderData?.orderType.toLowerCase() === 'pending' &&
        cartItems.length === 1
      ) {
        if (sameCartIdentity(cartProduct, item) && cartProduct.Quantity === 1) {
          RemoveItem(item, () => {
            dispatch(exitEditingCurrentOrder() as any);
          });
        } else {
          handleSubproductQuantity(item);
        }
      } else {
        if (orderDetails?.orderType?.toLowerCase() === 'partial') {
          if (updatingCartitems) {
            if (item.Quantity <= item.bp_order_paid_quantity) {
              if (
                cartItems.find(cartItem => {
                  if (sameCartIdentity(cartItem, item)) {
                    if (item.price_type === 'unit') {
                      if (
                        item.bp_order_paid_mass &&
                        item.bp_order_paid_mass > 0
                      ) {
                        return true;
                      }
                    } else {
                      if (
                        item.bp_order_paid_quantity &&
                        item.bp_order_paid_quantity > 0
                      ) {
                        return true;
                      }
                    }
                  }
                  return false;
                })
              ) {
                AppSnackbar.show(
                  'This item is fully or partially paid. It cannot be removed. Cancel the order instead.',
                  'warning',
                  { durationMs: 5000 },
                );
                return;
              }
            }
          }
        }
        if (item.Quantity <= 1) {
          const willEmptyEditing =
            updatingCartitems &&
            cartItems.length === 1 &&
            sameCartIdentity(cartProduct, item);
          RemoveItem(item, () => {
            if (willEmptyEditing) {
              dispatch(exitEditingCurrentOrder() as any);
            }
          });
        } else {
          handleSubproductQuantity(item);
        }
      }
    },
    [dispatch, cartItems, orderDetails, updatingCartitems],
  );

  // Helper function to check if selling price editing is allowed
  const canEditSellingPrice = useCallback(
    (item: CartItem): boolean => {
      // Check location setting: if price editing is disabled, return false
      const allowPriceEdit =
        currentLocation?.bp_location_settings
          ?.bp_location_allow_price_edit_during_checkout;
      if (allowPriceEdit === false) {
        return false;
      }

      // For item-type products: if bp_order_paid_quantity >= 1, no price change allowed
      // For unit-type products: if bp_order_paid_mass > 0, no price change allowed
      if (item.price_type === 'item') {
        return (item.bp_order_paid_quantity ?? 0) < 1;
      } else {
        // unit type
        return (item.bp_order_paid_mass ?? 0) <= 0;
      }
    },
    [currentLocation],
  );

  const handleUpdateSellingPrice = useCallback(
    (newSellingPrice: number) => {
      if (sellingPriceEditItem) {
        // Additional guardrail check before dispatching
        if (!canEditSellingPrice(sellingPriceEditItem)) {
          const allowPriceEdit =
            currentLocation?.bp_location_settings
              ?.bp_location_allow_price_edit_during_checkout;
          const errorMessage =
            allowPriceEdit === false
              ? 'Price editing is not allowed for this location'
              : 'Cannot edit selling price: Product has already been paid for';
          handleError(errorMessage, 'error', true);
          setSellingPriceEditItem(null);
          return;
        }
        dispatch(
          updateCartItemSellingPrice({
            productID: sellingPriceEditItem.productID,
            variantId: sellingPriceEditItem.variantId,
            sellingPrice: newSellingPrice,
          }),
        );
        dispatch(getTotals());
        setSellingPriceEditItem(null);
      }
    },
    [
      dispatch,
      sellingPriceEditItem,
      canEditSellingPrice,
      handleError,
      currentLocation,
    ],
  );

  const showName = useCallback(() => {
    setVisibleName(true);
  }, [setVisibleName]);

  const [orderitems, setOrderItems] = useState<OrderItem[]>([]);

  const buildCreateOrderPayload = useCallback(
    (validatedOrderItems: OrderItem[]) => {
      const payload: Record<string, any> = {
        bp_order_items_information: validatedOrderItems,
        bp_order_customer_information:
          input.length > 0 ? input : 'Walk in customer',
        bp_order_customer_id: selectedCustomerId ?? null,
      };
      if (isStaffAssignmentEnabled && assignedStaffId) {
        payload.bp_order_assigned_staff_id = assignedStaffId;
      }
      if (
        isEmployeeWaiterRole(employeedata?.bp_employee_role) &&
        employeedata?._id
      ) {
        payload.bp_order_assigned_staff_id = employeedata._id;
      }
      return payload;
    },
    [
      input,
      selectedCustomerId,
      isStaffAssignmentEnabled,
      assignedStaffId,
      employeedata,
    ],
  );

  useFocusEffect(
    useCallback(() => {
      if (!navigation.isFocused()) {
        return;
      }
      if (!cartItems || cartItems.length === 0) {
        setOrderItems([]);
        return;
      }

      const validOrderItems: OrderItem[] = cartItems
        .map(mapCartItemToOrderItem)
        .filter((item): item is OrderItem => item !== null);

      console.log('validOrderItems from cart:', validOrderItems);

      const invalidItems = cartItems.filter(
        (cartItem, index) => mapCartItemToOrderItem(cartItem) === null,
      );
      if (invalidItems.length > 0) {
        console.warn('Invalid cart items found:', invalidItems);
        const invalidKey = getCartIdentityKey(invalidItems[0]);
        if (invalidItems[0].price_type === 'item') {
          setQuantityInputError(prevErrors => ({
            ...prevErrors,
            [invalidKey]: true,
          }));
        } else {
          setTextInputError(prevErrors => ({
            ...prevErrors,
            [invalidKey]: true,
          }));
        }
      } else {
        setTextInputError(prevErrors => ({
          ...prevErrors,
          [getCartIdentityKey(invalidItems[0])]: false,
        }));
        setQuantityInputError(prevErrors => ({
          ...prevErrors,
          [getCartIdentityKey(invalidItems[0])]: false,
        }));
      }

      console.log('validOrderItems from cart:', validOrderItems);

      setOrderItems(validOrderItems);
    }, [cartItems]),
  );

  //save
  const SendOrder = useCallback(async () => {
    if (!networkAvailableGlobal) {
      handleError(
        'No internet connection. Please check your network.',
        'error',
        true,
      );
      return;
    }
    setIsSaving(true);
    try {
      const isLessthanZero = cartItems.find((item: CartItem) => {
        if (item.productID === item.productID) {
          if (item.price_type === 'unit') {
            //correct
            return item.mass !== undefined && item.mass <= 0;
          } else {
            //correct
            return item.Quantity !== undefined && item.Quantity <= 0;
          }
        }
        return false;
      });

      if (isLessthanZero) {
        handleError(
          `The quantity of ${isLessthanZero.itemname} is invalid, please check the order`,
          'error',
          true,
        );
        return;
      }
      // Validate all order items before sending
      const validatedOrderItems = orderitems.filter(item => {
        // Ensure all required keys are present and valid
        if (!validateOrderItem(item)) {
          console.error('Invalid order item:', item);
          return false;
        }
        return true;
      });

      console.log('validatedOrderItems', validatedOrderItems);

      if (validatedOrderItems.length === 0) {
        handleError(
          'No valid items to process. Please check your cart items.',
          'error',
          true,
        );
        return;
      }

      console.log('Validated order items for SendOrder:', validatedOrderItems);

      const createOrderPayload = buildCreateOrderPayload(validatedOrderItems);
      const response = await axiosprivate.post(
        'bp_add_order_information',
        JSON.stringify(createOrderPayload),
        { headers: { Authorization: 'Bearer ' + auth.accessToken } },
      );
      console.log('bp_add_order_information', response);
      if (response.data.status === 200) {
        const syncedOrder = response?.data?.order;
        if (syncedOrder?.bp_order_id) {
          dispatch(upsertOrderDoc(syncedOrder));
        }
        // Capture amounts before Clear() wipes cart totals.
        appAnalytics.track('commerce_pay_later_saved', {
          ...buildAppAnalyticsContext({
            role: employeedata?.bp_employee_role,
            locationType: currentLocation?.bp_location_is_system_generated
              ? 'test'
              : currentLocation
                ? 'real'
                : undefined,
          }),
          variant: canCheckout ? 'pay_later' : 'send_to_cashier',
          item_count: cartItems.length,
          order_total: cart?.cartTotalAmount,
        });
        if (response.data.orderNotAdded.length > 0) {
          setVisibleName(false);
          console.log(response);
          handleError(
            'The order has been saved,Some items were not added as there are out of stock',
            'success',
            true,
          );
          Clear();
          setInput('');
          setSelectedCustomerId(null);
        } else {
          setVisibleName(false);
          setInput('');
          setSelectedCustomerId(null);
          handleError('The order has been saved ', 'success', true);

          const order = response?.data?.order;
          const productsData = order.bp_sales_products_information;
          const productArray = productsData.map(
            (product: any) => product.bp_product_information,
          );
          dispatch(updateProductsAfterCheckout(productArray));
        }
        ReviewService.onEligibleAction('ORDER_SAVED');
        Clear();
      } else {
        if (response.data.message) {
          handleError(response.data.message, 'error', true);
        } else {
          handleError('An error occurred, please try again', 'error', true);
        }
      }
    } catch (error: any) {
      console.log(error);
      if (error.response.data.message) {
        handleError(error.response.data.message, 'error', true);
      } else {
        handleError('An error occurred, please try again', 'error', true);
      }
    } finally {
      setIsSaving(false);
    }
  }, [
    cartItems,
    orderitems,
    buildCreateOrderPayload,
    auth,
    dispatch,
    networkAvailableGlobal,
    handleError,
    employeedata?.bp_employee_role,
    currentLocation,
    canCheckout,
    cart?.cartTotalAmount,
  ]);
  //update
  const patchOrders = useCallback(async () => {
    setIsPatching(true);
    setIsLoading(true);
    try {
      const orderID = orderDetails?.orderID;
      if (!orderID) {
        return handleError(
          'An error occurred, Please try again, if the order was saved previously, cancel and retry',
          'error',
          true,
        );
      }

      const isMassLess = cartItems?.find(
        (item: CartItem) =>
          item.price_type === 'unit' &&
          item.bp_order_paid_mass &&
          item.mass !== undefined &&
          item.bp_order_paid_mass > item.mass,
      );

      if (isMassLess) {
        handleError(
          `The mass of ${isMassLess.itemname} is less than already paid mass of ${formatNumberDecimal(isMassLess.bp_order_paid_mass ?? 0)}, please check the order`,
          'error',
          true,
        );
        return;
      }
      const isQuantityLess = cartItems?.find(
        (item: CartItem) =>
          item.price_type === 'item' &&
          item.bp_order_paid_quantity &&
          item.Quantity !== undefined &&
          item.bp_order_paid_quantity > item.Quantity,
      );
      console.log('isQuantityLess', isQuantityLess, cartItems);
      if (isQuantityLess) {
        handleError(
          `The quantity of ${isQuantityLess.itemname} is less than already paid quantity of ${isQuantityLess.bp_order_paid_quantity}, please check the order`,
          'error',
          true,
        );
        return;
      }

      // Validate all order items before sending
      const validatedOrderItems = orderitems.filter(item => {
        console.log('Patchable item', item);
        // Ensure all required keys are present and valid
        if (!validateOrderItem(item)) {
          console.error('Invalid order item in patchOrders:', item);
          return false;
        }

        // Additional business logic validation
        if (item.bp_order_price_type === 'unit') {
          return item.bp_order_mass !== null && item.bp_order_mass > 0;
        } else {
          return item.bp_order_quantity !== null && item.bp_order_quantity > 0;
        }
      });

      if (validatedOrderItems.length === 0) {
        setIsLoading(false);
        handleError(
          'No valid items to process. Please check your cart items.',
          'error',
          true,
        );
        return;
      }

      console.log(
        'Validated order items for patchOrders:',
        validatedOrderItems,
      );

      //Always make sure order has bp_product_id information.

      const response = await axiosprivate.patch(
        'bp_update_selected_order_product_information',
        JSON.stringify({
          bp_order_items_information: validatedOrderItems,
          bp_order_id: orderID,
        }),
        { headers: { Authorization: 'Bearer ' + auth.accessToken } },
      );
      console.log('patch response', response);
      if (response.data.status === 200) {
        const syncedOrder = response?.data?.orderInformation;
        if (syncedOrder?.bp_order_id) {
          dispatch(upsertOrderDoc(syncedOrder));
        }
        if (response.data.productNotAdded.length > 0) {
          setIsLoading(false);
          setIsPatching(false);
          handleError(
            'The order has been saved,Some items were not added as there are out of stock',
            'success',
            true,
          );
          dispatch(clearOrderDetails());
          Clear();
          setInput('');
          setSelectedCustomerId(null);
        } else {
          const order = response?.data?.orderInformation;
          const productsData = order.bp_sales_products_information;
          const productArray = productsData.map(
            (product: any) => product.bp_product_information,
          );
          dispatch(updateProductsAfterCheckout(productArray));
          setIsLoading(false);
          handleError('The order has been updated and saved ', 'success', true);
          dispatch(clearOrderDetails());
          Clear();
        }
        ReviewService.onEligibleAction('ORDER_SAVED');
      } else {
        setIsLoading(false);
        setIsPatching(false);
        if (response.data.message) {
          handleError(response.data.message, 'error', true);
        } else {
          handleError('An error occurred, please try again', 'error', true);
        }
      }
    } catch (error: any) {
      setIsLoading(false);
      setIsPatching(false);
      console.log('patchOrdersError', error);
      if (error.response.data.message) {
        handleError(error.response.data.message, 'error', true);
      } else {
        handleError('An error occurred, please try again', 'error', true);
      }
    } finally {
      setIsPatching(false);
      setIsLoading(false);
    }
  }, [cartItems, orderitems, auth, dispatch]);

  const handlePatchOrders = useCallback(() => {
    if (!networkAvailableGlobal) {
      handleError(
        'No internet connection. Please check your network.',
        'error',
        true,
      );
      return;
    }
    //variable named pendingPreviousOrder stores previos order detail also for partial orders
    //separate in future for clarity
    const previousOrder = new Map(
      pendingPreviousOrder.map(order => [
        `${order.productID}::${order.variantId ?? ''}`,
        order,
      ]),
    );
    let hasNewItems = false;
    let hasQuantityChanges = false;
    let hasMassChanges = false;
    let orderlengthchanged = false;
    const hasPriceChanges = cartItems.some(
      (item: CartItem) => item.bp_selling_price_changed === true,
    );

    if (previousOrder.size !== orderitems.length) {
      orderlengthchanged = true;
    } else {
      //a more deep check on the quantity each individual item
      for (const item of orderitems) {
        const existingOrder = previousOrder.get(
          `${item.bp_product_id}::${item.bp_variant_id ?? ''}`,
        );
        // console.log('existingOrder', existingOrder);
        if (existingOrder) {
          if (
            existingOrder.price_type === 'item' &&
            item.bp_order_quantity !== existingOrder.Quantity
          ) {
            hasQuantityChanges = true;
          }
          // Check for mass changes if price type is 'unit'
          if (
            existingOrder.price_type === 'unit' &&
            item.bp_order_mass !== existingOrder.mass
          ) {
            hasMassChanges = true;
          }
        } else {
          hasNewItems = true;
        }
      }
    }
    //make sure all cartItems products that have a paid quanity of 0 or above exist
    const hasLessThanPaidQuantityorMass = cartItems.find((item: CartItem) => {
      if (item.productID === item.productID) {
        if (item.price_type === 'unit') {
          if (
            item.bp_order_paid_mass &&
            item.mass !== undefined &&
            item.mass !== null &&
            item.bp_order_paid_mass > item.mass
          ) {
            return true;
          }
        } else {
          if (
            item.bp_order_paid_quantity &&
            item.Quantity !== undefined &&
            item.bp_order_paid_quantity > item.Quantity
          ) {
            return true;
          }
        }
      }
      return false;
    });
    console.log('hasLessThanPaidQuantity', hasLessThanPaidQuantityorMass);
    if (hasLessThanPaidQuantityorMass) {
      handleError(
        `The quantity of ${hasLessThanPaidQuantityorMass.itemname} is less than already paid quantity of ${hasLessThanPaidQuantityorMass.price_type === 'unit' ? formatNumberDecimal(hasLessThanPaidQuantityorMass.bp_order_paid_mass ?? 0) : hasLessThanPaidQuantityorMass.bp_order_paid_quantity}, please check the order`,
        'error',
        true,
      );
      return;
    }

    const isLessthanZero = cartItems.find((item: CartItem) => {
      if (item.productID === item.productID) {
        if (item.price_type === 'unit') {
          //correct
          return item.mass !== undefined && item.mass <= 0;
        } else {
          //correct
          return item.Quantity !== undefined && item.Quantity <= 0;
        }
      }
      return false;
    });

    if (isLessthanZero) {
      handleError(
        `The quantity of ${isLessthanZero.itemname} is invalid, please check the order`,
        'error',
        true,
      );
      return;
    }
    console.log(
      'hasNewItems',
      hasNewItems,
      'hasQuantityChanges',
      hasQuantityChanges,
      'hasMassChanges',
      hasMassChanges,
      'orderlengthchanged',
      orderlengthchanged,
      'hasPriceChanges',
      hasPriceChanges,
    );
    if (
      hasNewItems ||
      hasQuantityChanges ||
      hasMassChanges ||
      orderlengthchanged ||
      hasPriceChanges
    ) {
      patchOrders();
    } else {
      handleError(
        'You cannot update this order because it already exists and there are no changes, please add new products or modify quantities/mass to update',
        'error',
        true,
      );
    }
  }, [cartItems, orderitems, orderDetails, pendingPreviousOrder, dispatch]);

  const handleSaveOrder = useCallback(() => {
    const isLessthanZero = cartItems.find((item: CartItem) => {
      if (item.productID === item.productID) {
        if (item.price_type === 'unit') {
          //correct
          return item.mass !== undefined && item.mass <= 0;
        } else {
          //correct
          return item.Quantity !== undefined && item.Quantity <= 0;
        }
      }
      return false;
    });

    if (isLessthanZero) {
      handleError(
        `The quantity of ${isLessthanZero.itemname} is invalid, please check the order`,
        'error',
        true,
      );
      return;
    }
    showName();
  }, [cartItems, orderitems, pendingPreviousOrder, dispatch]);

  //checkout
  const SendOrderBeforeCheckout =
    useCallback(async (): Promise<CheckoutNavigationPayload | null> => {
      setIsCheckingOut(true);
      setIsLoading(true);
      let checkoutPayload: CheckoutNavigationPayload | null = null;

      try {
        const hasLessThanPaidQuantityorMass = cartItems.find(
          (item: CartItem) => {
            if (item.productID === item.productID) {
              if (item.price_type === 'unit') {
                if (
                  item.bp_order_paid_mass &&
                  item.mass !== undefined &&
                  item.mass !== null &&
                  item.bp_order_paid_mass > item.mass
                ) {
                  return true;
                }
              } else {
                if (
                  item.bp_order_paid_quantity &&
                  item.Quantity !== undefined &&
                  item.bp_order_paid_quantity > item.Quantity
                ) {
                  return true;
                }
              }
            }
            return false;
          },
        );
        console.log('hasLessThanPaidQuantity', hasLessThanPaidQuantityorMass);
        if (hasLessThanPaidQuantityorMass) {
          handleError(
            `The quantity of ${hasLessThanPaidQuantityorMass.itemname} is less than already paid quantity of ${hasLessThanPaidQuantityorMass.price_type === 'unit' ? formatNumberDecimal(hasLessThanPaidQuantityorMass.bp_order_paid_mass ?? 0) : hasLessThanPaidQuantityorMass.bp_order_paid_quantity}, please check the order`,
            'error',
            true,
          );
          return null;
        }

        const isLessthanZero = cartItems.find((item: CartItem) => {
          if (item.productID === item.productID) {
            if (item.price_type === 'unit') {
              return item.mass !== undefined && item.mass <= 0;
            } else {
              return item.Quantity !== undefined && item.Quantity <= 0;
            }
          }
          return false;
        });

        if (isLessthanZero) {
          handleError(
            `The quantity of ${isLessthanZero.itemname} is invalid, please check the order`,
            'error',
            true,
          );
          return null;
        }

        const validatedOrderItems = orderitems.filter(item => {
          console.log('Patchable item', item);
          if (!validateOrderItem(item)) {
            console.error(
              'Invalid order item in SendOrderBeforeCheckout:',
              item,
            );
            return false;
          }

          if (item.bp_order_price_type === 'unit') {
            return item.bp_order_mass !== null && item.bp_order_mass > 0;
          } else {
            return (
              item.bp_order_quantity !== null && item.bp_order_quantity > 0
            );
          }
        });

        if (validatedOrderItems.length === 0) {
          handleError(
            'No valid items to process. Please check your cart items.',
            'error',
            true,
          );
          return null;
        }

        console.log(
          'Validated order items for SendOrderBeforeCheckout:',
          validatedOrderItems,
        );
        // return null;
        // const startTime = performance.now();
        const createOrderPayload = buildCreateOrderPayload(validatedOrderItems);
        const response = await axiosprivate.post(
          'bp_add_order_information',
          JSON.stringify(createOrderPayload),
          { headers: { Authorization: 'Bearer ' + auth.accessToken } },
        );
        console.log('bp_add_order_information', response);
        if (response.data.status === 200) {
          const order = response?.data?.order;
          if (order?.bp_order_id) {
            dispatch(upsertOrderDoc(order));
          }
          dispatch(
            addToCartOrderData({
              order: order.bp_sales_products_information,
              orderID: order.bp_order_id,
              orderType: 'PENDING',
              customerName: input.length > 0 ? input : 'Walk in customer',
              ...orderCustomerContactFromDoc(order),
            }),
          );
          dispatch(setUpdatingCartitems(true));
          setReceipt({
            order: order.bp_sales_products_information,
            orderID: order.bp_order_id,
            Payment_Information: order.bp_order_master_payment_information,
            ReceiptID: order.bp_order_master_receipt_reference_id ?? '',
          });
          checkoutPayload = {
            order: order.bp_sales_products_information,
            orderID: order.bp_order_id,
            Payment_Information: order.bp_order_master_payment_information,
            ReceiptID: order.bp_order_master_receipt_reference_id ?? '',
          };
          if (response.data.orderNotAdded.length > 0) {
            console.log(response);
            handleError(
              'Some items are out of stock, they have not been added to the order',
              'error',
              true,
            );
            dispatch(
              setOrderDetails({
                orderID: order.bp_order_id,
                orderType: 'pending',
                customerName: '',
              }),
            );
          } else {
            dispatch(
              setOrderDetails({
                orderID: order.bp_order_id,
                orderType: 'pending',
                customerName: '',
              }),
            );
            console.log(order);
            // const endTime = performance.now();
            // const duration = endTime - startTime;
            // console.log(`Code execution took ${duration} milliseconds.`);
            const productsData = order.bp_sales_products_information;
            const productArray = productsData.map(
              (product: any) => product.bp_product_information,
            );
            dispatch(updateProductsAfterCheckout(productArray));
          }
        } else {
          if (response.data.message) {
            handleError(response.data.message, 'error', true);
          } else {
            handleError('An error occurred, please try again', 'error', true);
          }
        }
      } catch (error: any) {
        console.log('SendOrderBeforeCheckoutError', error);
        if (error?.response?.data?.message) {
          handleError(error.response.data.message, 'error', true);
        } else {
          handleError('An error occurred, please try again', 'error', true);
        }
      } finally {
        setIsCheckingOut(false);
        setIsLoading(false);
      }

      return checkoutPayload;
    }, [
      cartItems,
      orderitems,
      pendingPreviousOrder,
      dispatch,
      auth?.accessToken,
      axiosprivate,
      buildCreateOrderPayload,
      input,
      handleError,
      setReceipt,
    ]);

  //checkout update
  const PatchOrderBeforeCheckout =
    useCallback(async (): Promise<CheckoutNavigationPayload | null> => {
      setIsLoading(true);
      setIsCheckingOut(true);
      let checkoutPayload: CheckoutNavigationPayload | null = null;
      try {
        const orderID = orderDetails?.orderID;
        if (!orderID) {
          handleError(
            'An error occurred, Please try again, if the order was saved previously, cancel and retry',
            'error',
            true,
          );
          return null;
        }

        const isLessthanZero = cartItems.find((item: CartItem) => {
          if (item.productID === item.productID) {
            if (item.price_type === 'unit') {
              return item.mass !== undefined && item.mass <= 0;
            } else {
              return item.Quantity !== undefined && item.Quantity <= 0;
            }
          }
          return false;
        });

        if (isLessthanZero) {
          handleError(
            `The quantity of ${isLessthanZero.itemname} is invalid, please check the order`,
            'error',
            true,
          );
          return null;
        }

        const validatedOrderItems = orderitems.filter(item => {
          console.log('Patchable item', item);
          if (!validateOrderItem(item)) {
            console.error(
              'Invalid order item in PatchOrderBeforeCheckout:',
              item,
            );
            return false;
          }
          if (item.bp_order_price_type === 'unit') {
            return item.bp_order_mass !== null && item.bp_order_mass > 0;
          } else {
            return (
              item.bp_order_quantity !== null && item.bp_order_quantity > 0
            );
          }
        });

        console.log('validatedOrderItems', validatedOrderItems);

        if (validatedOrderItems.length === 0) {
          handleError(
            'No valid items to process. Please check your cart items.',
            'error',
            true,
          );
          return null;
        }

        const isMassLess = cartItems?.find(
          (item: CartItem) =>
            item.price_type === 'unit' &&
            item.bp_order_paid_mass &&
            item.mass !== undefined &&
            item.bp_order_paid_mass > item.mass,
        );
        const isQuantityLess = cartItems?.find(
          (item: CartItem) =>
            item.price_type === 'item' &&
            item.bp_order_paid_quantity &&
            item.Quantity !== undefined &&
            item.bp_order_paid_quantity > item.Quantity,
        );
        if (isMassLess) {
          handleError(
            `The mass of ${isMassLess.itemname} is less than already paid mass of ${formatNumberDecimal(isMassLess.bp_order_paid_mass ?? 0)}, please check the order`,
            'error',
            true,
          );
          return null;
        }
        if (isQuantityLess) {
          handleError(
            `The quantity of ${isQuantityLess.itemname} is less than already paid quantity of ${isQuantityLess.bp_order_paid_quantity}, please check the order`,
            'error',
            true,
          );
          return null;
        }
        const response = await axiosprivate.patch(
          'bp_update_selected_order_product_information',
          JSON.stringify({
            bp_order_items_information: validatedOrderItems,
            bp_order_id: orderID,
          }),
          { headers: { Authorization: 'Bearer ' + auth.accessToken } },
        );
        console.log('PatchOrderBeforeCheckout', response);
        if (response.data.status === 200) {
          const order = response?.data?.orderInformation;
          if (order?.bp_order_id) {
            dispatch(upsertOrderDoc(order));
          }
          dispatch(setUpdatingCartitems(true));
          dispatch(
            addToCartOrderData({
              order: order.bp_sales_products_information,
              orderID: order.bp_order_id,
              orderType: order.bp_order_master_order_status,
              customerName: order.bp_order_customer_information,
              ...orderCustomerContactFromDoc(order),
            }),
          );
          setReceipt({
            order: order.bp_sales_products_information,
            orderID: order.bp_order_id,
            Payment_Information: order.bp_order_master_payment_information,
            ReceiptID: order.bp_order_master_receipt_reference_id ?? '',
          });

          checkoutPayload = {
            order: order.bp_sales_products_information,
            orderID: order.bp_order_id,
            Payment_Information: order.bp_order_master_payment_information,
            ReceiptID: order.bp_order_master_receipt_reference_id ?? '',
          };
          if (response.data.productNotAdded.length > 0) {
            handleError(
              'Some items are out of stock, they have not been added to the order',
              'error',
              true,
            );
          } else {
            const productsData = order.bp_sales_products_information;
            const productArray = productsData.map(
              (product: any) => product.bp_product_information,
            );
            dispatch(updateProductsAfterCheckout(productArray));
            console.log(order);
          }
        } else {
          console.log('PatchOrderBeforeCheckoutError', response);
          if (response.data.message) {
            handleError(response.data.message, 'error', true);
          } else {
            handleError('An error occurred, please try again', 'error', true);
          }
        }
      } catch (error: any) {
        console.log('PatchOrderBeforeCheckoutError', error);
        if (error?.response?.data?.message) {
          handleError(error.response.data.message, 'error', true);
        } else {
          handleError('An error occurred, please try again', 'error', true);
        }
      } finally {
        setIsCheckingOut(false);
        setIsLoading(false);
      }
      return checkoutPayload;
    }, [
      cartItems,
      orderitems,
      pendingPreviousOrder,
      dispatch,
      auth?.accessToken,
      axiosprivate,
      handleError,
      orderDetails?.orderID,
      setReceipt,
    ]);

  const handleCheckoutButtonPress = useCallback(async () => {
    if (!networkAvailableGlobal) {
      handleError(
        'No internet connection. Please check your network.',
        'error',
        true,
      );
      return;
    }
    try {
      const payload = updatingCartitems
        ? await PatchOrderBeforeCheckout()
        : await SendOrderBeforeCheckout();
      if (payload) {
        const orderLines = Array.isArray(payload.order) ? payload.order : [];
        const paymentAmount = Number(
          payload.Payment_Information?.bp_payment_amount,
        );
        appAnalytics.track('commerce_checkout_started', {
          ...buildAppAnalyticsContext({
            role: employeedata?.bp_employee_role,
            locationType: currentLocation?.bp_location_is_system_generated
              ? 'test'
              : currentLocation
                ? 'real'
                : undefined,
          }),
          source: 'cart',
          // Use post-API order payload (stock drops may shrink vs cart).
          item_count: orderLines.length,
          order_total: Number.isFinite(paymentAmount)
            ? paymentAmount
            : undefined,
        });
        navigation.navigate('Checkout', payload);
      }
    } catch (error) {
      // Error handling is done in the API functions
    }
  }, [
    PatchOrderBeforeCheckout,
    SendOrderBeforeCheckout,
    updatingCartitems,
    networkAvailableGlobal,
    handleError,
    navigation,
    employeedata?.bp_employee_role,
    currentLocation,
  ]);

  const handleClose = useCallback(
    (item: CartItem) => {
      if (orderDetails?.orderType?.toLowerCase() === 'partial') {
        if (
          cartItems.find(cartItem => {
            if (sameCartIdentity(cartItem, item)) {
              if (item.price_type === 'unit') {
                if (item.bp_order_paid_mass && item.bp_order_paid_mass > 0) {
                  return true;
                }
              } else {
                if (
                  item.bp_order_paid_quantity &&
                  item.bp_order_paid_quantity > 0
                ) {
                  return true;
                }
              }
            }
            return false;
          })
        ) {
          AppSnackbar.show(
            'This item is fully or partially paid. It cannot be removed. Cancel the order instead.',
            'warning',
            { durationMs: 5000 },
          );
          return;
        }
      }
      AppAlert.alert(
        'Remove item ? ',
        `Are you sure you want to remove ${item.itemname ?? 'this item'} from cart?`,
        [
          {
            text: 'Cancel',
            onPress: () => {
              return;
            },
            style: 'cancel',
          },
          {
            text: 'OK',
            onPress: () => {
              if (cartItems?.length === 1) {
                Clear();
              } else {
                dispatch(removeCartItem(item));
              }
            },
          },
        ],
      );
    },
    [cartItems, orderDetails, dispatch],
  );

  const handleInputChange = useCallback(
    (item: CartItem, input: string) => {
      // Remove leading zeros except for zero itself
      let sanitizedInput: string;
      const digitInput = input.replace(/^0+(?=\d)/, '');
      setMassValues(prevValues => ({
        ...prevValues,
        [getCartIdentityKey(item)]: digitInput,
      }));
      if (digitInput.endsWith('.')) {
        if (updatingCartitems) {
          const cartItem = cart?.cartItems?.find(existingCartItem =>
            sameCartIdentity(existingCartItem, item),
          );
          setTextInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]:
              Number(digitInput) < (cartItem?.bp_order_paid_mass ?? 0),
          }));
        }
        return;
      }
      if (updatingCartitems) {
        const cartItem = cart?.cartItems?.find(existingCartItem =>
          sameCartIdentity(existingCartItem, item),
        );
        if (Number(digitInput) < (cartItem?.bp_order_paid_mass ?? 0)) {
          setTextInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]: true,
          }));
          setMassValues(prevValues => ({
            ...prevValues,
            [getCartIdentityKey(item)]: digitInput,
          }));
          dispatch(
            addToCart({
              ...item,
              mass: Number(digitInput),
            }),
          );
          return;
        } else {
          setTextInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]: false,
          }));
        }
      }
      sanitizedInput = digitInput;

      if (/^\d*\.?\d*$/.test(sanitizedInput)) {
        const numericValue = parseFloat(sanitizedInput);
        // Handle valid number or empty input (0 when cleared)
        const newMass = sanitizedInput === '' ? 0 : numericValue || 0;
        console.log('newMass', newMass);
        const originalProduct = cartOrderData?.order?.find(orderLine =>
          sameOrderLineIdentity(orderLine, item),
        );
        if (
          updatingCartitems &&
          originalProduct?.bp_product_information?.bp_product_price_type
        ) {
          const baseStock = getOrderLineAvailableStock(originalProduct, item);
          const unpaidMass =
            originalProduct?.bp_order_mass -
            (originalProduct?.bp_order_paid_mass ?? 0);
          const unpaidQuantity =
            originalProduct?.bp_order_quantity -
            (originalProduct?.bp_order_paid_quantity ?? 0);

          const totalProductQuantity =
            item.price_type === 'unit'
              ? roundToNumericPrecision(
                  baseStock +
                    unpaidMass +
                    (originalProduct?.bp_order_paid_mass ?? 0),
                )
              : baseStock +
                unpaidQuantity +
                (originalProduct?.bp_order_paid_quantity ?? 0);

          console.log('totalProductQuantity', totalProductQuantity);
          console.log('newMass', newMass);

          // A service keeps no stock, so no mass is too much
          if (!isStockTracked(item.kind) || newMass <= totalProductQuantity) {
            setTextInputError(prevErrors => ({
              ...prevErrors,
              [getCartIdentityKey(item)]: false,
            }));
            setMassValues(prevValues => ({
              ...prevValues,
              [getCartIdentityKey(item)]: sanitizedInput,
            }));
            dispatch(
              addToCart({
                ...item,
                mass: newMass,
              }),
            );
          } else {
            if (newMass >= 0) {
              handleError(
                `value is greater than available stock of ${formatNumberDecimal(
                  totalProductQuantity,
                )} ${item.unitofmass}`,
                'error',
                true,
              );
              console.log('maybehere1');
              if (newMass > 0) {
                setTextInputError(prevErrors => ({
                  ...prevErrors,
                  [getCartIdentityKey(item)]: true,
                }));
              }
            }
          }
        } else {
          if (!isStockTracked(item.kind) || newMass <= (item.quantity ?? 0)) {
            setTextInputError(prevErrors => ({
              ...prevErrors,
              [getCartIdentityKey(item)]: false,
            }));
            dispatch(
              addToCart({
                ...item,
                mass: newMass,
              }),
            );
          } else {
            if (newMass >= 0) {
              // toast.show(
              //   `value is greater than available stock of ${item.quantity} ${item.unitofmass}`,
              //   {
              //     animationType: 'slide-in',
              //     duration: 2000,
              //     textStyle: { fontSize: 14 },
              //     animationDuration: 50,
              //   },
              // );
              handleError(
                `value is greater than available stock of ${formatNumberDecimal(
                  item.quantity ?? 0,
                )} ${item.unitofmass}`,
                'error',
                true,
              );
              // if (newMass > 0) {
              //   setTextInputError(prevErrors => ({
              //     ...prevErrors,
              //     [item.productID]: true,
              //   }));
              // }
            }
          }
        }
        dispatch(getTotals());
      }
    },
    [cartItems, orderDetails, dispatch],
  );
  const handleQuantityInputChange = useCallback(
    (item: CartItem, input: string) => {
      // Remove leading zeros except for zero itself
      let sanitizedInput: number;
      const digitInput = input.replace(/^0+(?=\d)/, '');
      if (updatingCartitems) {
        const cartItem = cart?.cartItems?.find(existingCartItem =>
          sameCartIdentity(existingCartItem, item),
        );
        if (Number(digitInput) < (cartItem?.bp_order_paid_quantity ?? 0)) {
          setQuantityInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]: true,
          }));

          dispatch(
            addToCartQuantity({
              productID: item.productID,
              variantId: item.variantId,
              quantity: Number(digitInput) ?? 0,
            }),
          );

          // setMassValues(prevValues => ({
          //   ...prevValues,
          //   [item.productID]: String(item.bp_order_paid_mass),
          // }));
          // dispatch(
          //   addToCartQuantity({
          //     productID: item.productID,
          //     quantity: Number(item.bp_order_paid_quantity ?? 0),
          //   }),
          // );
          return;
        } else {
          setQuantityInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]: false,
          }));
        }
      }
      sanitizedInput = parseInt(digitInput) || 0;

      // Handle valid number or empty input (0 when cleared)
      const newQuantity = sanitizedInput || 0;
      console.log('newQuantity', newQuantity);
      const originalProduct = cartOrderData?.order?.find(orderLine =>
        sameOrderLineIdentity(orderLine, item),
      );
      if (
        updatingCartitems &&
        originalProduct?.bp_product_information?.bp_product_price_type
      ) {
        const baseStock = getOrderLineAvailableStock(originalProduct, item);
        const unpaidMass =
          originalProduct?.bp_order_mass -
          (originalProduct?.bp_order_paid_mass ?? 0);
        const unpaidQuantity =
          originalProduct?.bp_order_quantity -
          (originalProduct?.bp_order_paid_quantity ?? 0);

        const totalProductQuantity =
          item.price_type === 'unit'
            ? baseStock +
              unpaidMass +
              (originalProduct?.bp_order_paid_mass ?? 0)
            : baseStock +
              unpaidQuantity +
              (originalProduct?.bp_order_paid_quantity ?? 0);

        // A service keeps no stock, so no quantity is too many
        if (
          !isStockTracked(item.kind) ||
          Number(sanitizedInput) <= Number(totalProductQuantity)
        ) {
          dispatch(
            addToCartQuantity({
              productID: item.productID,
              variantId: item.variantId,
              quantity: Number(sanitizedInput),
            }),
          );
          setQuantityInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]: false,
          }));
        } else {
          if (newQuantity >= 0) {
            handleError(
              `value is greater than available stock of ${totalProductQuantity} ${item.unitofmass}`,
              'error',
              true,
            );
            if (newQuantity > 0) {
              setQuantityInputError(prevErrors => ({
                ...prevErrors,
                [getCartIdentityKey(item)]: true,
              }));
            }
          }
        }
      } else {
        if (!isStockTracked(item.kind) || newQuantity <= (item.quantity ?? 0)) {
          setQuantityInputError(prevErrors => ({
            ...prevErrors,
            [getCartIdentityKey(item)]: false,
          }));
          dispatch(
            addToCartQuantity({
              productID: item.productID,
              variantId: item.variantId,
              quantity: newQuantity,
            }),
          );
        } else {
          if (newQuantity >= 0) {
            // toast.show(
            //   `value is greater than available stock of ${item.quantity} ${item.unitofmass}`,
            //   {
            //     animationType: 'slide-in',
            //     duration: 2000,
            //     textStyle: { fontSize: 14 },
            //     animationDuration: 50,
            //   },
            // );
            handleError(
              `value is greater than available stock of ${item.quantity} ${item.unitofmass}`,
              'error',
              true,
            );
            // if (newQuantity > 0) {
            //   setQuantityInputError(prevErrors => ({
            //     ...prevErrors,
            //     [item.productID]: true,
            //   }));
            // }
          }
        }
      }
      dispatch(getTotals());
    },
    [cartItems, orderDetails, dispatch],
  );

  const handleQuantityBlur = useCallback(
    (item: CartItem) => {
      if (!updatingCartitems) return;
      const live = cart?.cartItems?.find(existingCartItem =>
        sameCartIdentity(existingCartItem, item),
      );
      const paid = Number(live?.bp_order_paid_quantity ?? 0);
      if (paid <= 0) return;
      if ((live?.Quantity ?? 0) >= paid) return;

      dispatch(
        addToCartQuantity({
          productID: item.productID,
          variantId: item.variantId,
          quantity: paid,
        }),
      );
      dispatch(getTotals());
      setQuantityInputError(prevErrors => ({
        ...prevErrors,
        [getCartIdentityKey(item)]: false,
      }));
      AppSnackbar.show(
        'This item is fully or partially paid. It cannot be removed. Cancel the order instead.',
        'warning',
        { durationMs: 5000 },
      );
    },
    [updatingCartitems, cart?.cartItems, dispatch],
  );

  const handleMassBlur = useCallback(
    (item: CartItem) => {
      const live = cart?.cartItems?.find(existingCartItem =>
        sameCartIdentity(existingCartItem, item),
      );
      const paid = Number(live?.bp_order_paid_mass ?? 0);
      const raw = massValues[getCartIdentityKey(item)] ?? '';
      const parsed = parseFloat(raw);
      const current =
        raw === '' || !Number.isFinite(parsed) || parsed <= 0 ? 0 : parsed;

      if (updatingCartitems && paid > 0 && current < paid) {
        dispatch(
          addToCart({
            ...item,
            mass: paid,
          }),
        );
        dispatch(getTotals());
        setTextInputError(prevErrors => ({
          ...prevErrors,
          [getCartIdentityKey(item)]: false,
        }));
        setMassValues(prevValues => ({
          ...prevValues,
          [getCartIdentityKey(item)]: String(paid),
        }));
        AppSnackbar.show(
          'This item is fully or partially paid. It cannot be removed. Cancel the order instead.',
          'warning',
          { durationMs: 5000 },
        );
        return;
      }

      setMassValues(prev => ({
        ...prev,
        [getCartIdentityKey(item)]:
          live?.mass == null ? '' : String(roundToNumericPrecision(live.mass)),
      }));
    },
    [updatingCartitems, cart?.cartItems, massValues, dispatch],
  );

  console.log('massValues', massValues);

  return (
    <View style={styles.container}>
      <SaleCustomerBanner inset={useWidthConstraint} />
      {cartItems && cartItems?.length > 0 ? (
        <>
          <KeyboardAwareFormScroll
            style={styles.scrollViewContent}
            contentContainerStyle={styles.scrollContainer}
            keyboardShouldPersistTaps="handled"
            bottomOffset={v(240)}
            // extraKeyboardSpace={20}
          >
            <View style={styles.cartTopSection}>
              <TestLocationBanner variant="subtle" />
              <View style={styles.listHeaderRow}>
                <View style={styles.listHeaderLeft}>
                  <Text style={styles.listHeaderText}>Item</Text>
                  <Text style={styles.listHeaderCount}>
                    {cartItems.length} item(s)
                  </Text>
                </View>
                <Text style={styles.listHeaderText}>Price/Quantity</Text>
              </View>
            </View>

            {displayedCartItems &&
              displayedCartItems.map(item => {
                const unpaidMass =
                  Number(item.mass ?? 0) -
                  Number(item?.bp_order_paid_mass ?? 0);
                const unpaidQuantity =
                  (item.Quantity ?? 0) - (item.bp_order_paid_quantity ?? 0);
                const isFullyPaidPartial =
                  item.price_type === 'unit'
                    ? unpaidMass <= 0 || isNumericEffectivelyZero(unpaidMass)
                    : isNumericEffectivelyZero(unpaidQuantity);
                const isGestureMode =
                  useGestureQuantity && item.price_type !== 'unit';
                const onRowTap = () => {
                  if (!isGestureMode) return;
                  onAdd(item);
                };
                const onRowLongPress = () => {
                  if (!isGestureMode) return;
                  onSub(item);
                };
                const cartItemKey = getCartIdentityKey(item);
                const showsPaidPill = isFullyPaidPartial;
                const partialStatusLabel = showsPaidPill
                  ? item.price_type === 'unit'
                    ? `${formatNumberDecimal(Number(item.bp_order_paid_mass))} ${item.unitofmass} PAID`
                    : `${formatNumberDecimal(Number(item.bp_order_paid_quantity ?? item.Quantity))} PAID`
                  : item.price_type === 'unit'
                    ? `${formatNumberDecimal(unpaidMass)} ${item.unitofmass} UNPAID`
                    : `${formatNumberDecimal(unpaidQuantity)} UNPAID`;
                const displayItemName = item.variantId
                  ? item.itemname
                  : getProductDisplayName(item);

                return (
                  <Pressable
                    onPress={isGestureMode ? onRowTap : undefined}
                    onLongPress={isGestureMode ? onRowLongPress : undefined}
                    delayLongPress={200}
                    style={({ pressed, hovered }: any) => [
                      styles.box,
                      Platform.OS === 'web' && isGestureMode && styles.boxWeb,
                      Platform.OS === 'web' && hovered && styles.boxHovered,
                      pressed && isGestureMode && { opacity: 0.7 },
                    ]}
                    key={cartItemKey}>
                    <View style={styles.cardheader}>
                      <View style={styles.imageWrap}>
                        {item.image ? (
                          <Image
                            source={{ uri: item.image }}
                            style={styles.itemImage}
                          />
                        ) : (
                          <View style={styles.emptyImagePlaceholder}>
                            <FontAwesome6
                              name="image"
                              size={iconSize(20)}
                              color={theme.colors.textSecondary}
                            />
                          </View>
                        )}
                      </View>
                      <View style={styles.cardContent}>
                        <View style={styles.cardTopRow}>
                          <Text style={styles.itemname} numberOfLines={1}>
                            {displayItemName}
                          </Text>

                          <View style={styles.rightSection}>
                            <View style={styles.priceRow}>
                              {canEditSellingPrice(item) ? (
                                <TouchableOpacity
                                  onPress={() => {
                                    Keyboard.dismiss();
                                    setSellingPriceEditItem(item);
                                    setIsSellingPriceEditVisible(true);
                                  }}
                                  style={styles.editablePriceWrap}>
                                  <FontAwesome6
                                    name="pen"
                                    iconStyle="solid"
                                    size={iconSize(12)}
                                    color={theme.colors.primary}
                                  />
                                  <Text style={styles.qty}>
                                    {currencyTextLower}
                                    {'\u00A0'}
                                    {item.price
                                      ? item.price_type === 'unit'
                                        ? `${formatMoney(item.price)}/${item.unitofmass}`
                                        : formatMoney(item.price)
                                      : ''}
                                  </Text>
                                </TouchableOpacity>
                              ) : (
                                <Text style={styles.qty}>
                                  {currencyTextLower}
                                  {'\u00A0'}
                                  {item.price
                                    ? item.price_type === 'unit'
                                      ? `${formatMoney(item.price)}/${item.unitofmass}`
                                      : formatMoney(item.price)
                                    : ''}
                                </Text>
                              )}
                            </View>
                          </View>
                        </View>

                        <View style={styles.cardBottomRow}>
                          <View style={styles.metaColumn}>
                            {appendServiceMeta(item.category, item.kind) ? (
                              <Text
                                style={styles.categoryText}
                                numberOfLines={1}>
                                {appendServiceMeta(item.category, item.kind)}
                              </Text>
                            ) : null}
                            {orderDetails?.orderType?.toLowerCase() ===
                              'partial' &&
                              (originalOrderProductIdSet.has(cartItemKey) ||
                                item.bp_order_completed !== undefined) && (
                                <View
                                  style={
                                    showsPaidPill
                                      ? styles.paidPill
                                      : styles.unpaidPill
                                  }>
                                  <Text
                                    style={
                                      showsPaidPill
                                        ? styles.paidPillText
                                        : styles.unpaidPillText
                                    }
                                    numberOfLines={1}>
                                    {partialStatusLabel}
                                  </Text>
                                </View>
                              )}
                          </View>

                          <TouchableOpacity
                            style={styles.trashButton}
                            onPress={() => {
                              handleClose(item);
                            }}>
                            <FontAwesome6
                              name="trash"
                              iconStyle="solid"
                              size={iconSize(14)}
                              color={theme.colors.error}
                            />
                          </TouchableOpacity>
                        </View>
                      </View>
                    </View>
                    <View style={styles.itemBottom}>
                      <Text style={styles.subTotal}>
                        <Text style={styles.subTotalPrefix}>
                          Sub-Total:{'\u00A0'}
                        </Text>
                        {currencyTextLower}
                        {'\u00A0'}
                        {item.price_type === 'unit'
                          ? formatMoney(item.price * (item.mass ?? 0))
                          : formatMoney(item.price * (item.Quantity ?? 0))}
                      </Text>
                      <View style={styles.btnQuantity}>
                        {item.price_type === 'unit' ? (
                          <QuantityControls
                            priceType="unit"
                            quantity={0}
                            mass={item.mass ?? 0}
                            massText={String(
                              massValues[getCartIdentityKey(item)] ?? '',
                            )}
                            unitOfMass={item.unitofmass}
                            onAdd={() => onAdd(item)}
                            onSubtract={() => onSub(item)}
                            onQuantityChange={() => {}}
                            onMassChange={(input: string) =>
                              handleInputChange(item, input)
                            }
                            onMassBlur={() => handleMassBlur(item)}
                            useWebLayout={useWebLayout}
                            hasError={
                              !!textInputError[getCartIdentityKey(item)]
                            }
                          />
                        ) : useGestureQuantity ? (
                          <QuantityControls
                            priceType="item"
                            gestureMode
                            quantity={item.Quantity ?? 0}
                            onAdd={() => {}}
                            onSubtract={() => {}}
                            onQuantityChange={() => {}}
                            useWebLayout={useWebLayout}
                          />
                        ) : (
                          <QuantityControls
                            priceType="item"
                            quantity={item.Quantity ?? 0}
                            onAdd={() => onAdd(item)}
                            onSubtract={() => onSub(item)}
                            onQuantityChange={(input: string) =>
                              handleQuantityInputChange(item, input)
                            }
                            onQuantityBlur={() => handleQuantityBlur(item)}
                            useWebLayout={useWebLayout}
                            hasError={
                              !!quantityInputError[getCartIdentityKey(item)]
                            }
                            showPlusDisabledStyle={
                              isStockTracked(item.kind) &&
                              (item.quantity ?? 0) <= 0
                            }
                          />
                        )}
                      </View>
                    </View>
                  </Pressable>
                );
              })}
          </KeyboardAwareFormScroll>

          <KeyboardStickyView offset={{ closed: 0, opened: v(90) }}>
            <View style={styles.stickyButtonContainer}>
              <View
                style={[
                  styles.bottom,
                  {
                    paddingHorizontal: s(20),
                    marginBottom: v(15),
                  },
                ]}>
                <Text style={styles.Total}>Total:</Text>
                <Text style={styles.Total}>
                  {currencyTextCapital} {formatMoney(cart?.cartTotalAmount)}
                </Text>
              </View>
              {updatingCartitems ? (
                <View style={styles.Buttongrp}>
                  <Button
                    text={isCancelling ? 'Cancelling...' : 'Cancel'}
                    disabled={isCancelling || isPatching}
                    fontSize={fs(useWebLayout ? 13 : 12)}
                    backgroundColor={theme.colors.error}
                    rippleColor={theme.colors.errorDark}
                    loading={isCancelling}
                    paddingHorizontal={s(useWebLayout ? 36 : 24)}
                    borderRadius={theme.borderRadius.md}
                    height={v(useWebLayout ? 44 : 36)}
                    onPress={() =>
                      Cancel(
                        'Cancel Order ?',
                        'Are you sure you want to cancel this order?',
                      )
                    }
                  />
                  <Button
                    text={
                      isPatching
                        ? 'Updating...'
                        : canCheckout
                          ? 'Update'
                          : 'Update Order'
                    }
                    disabled={
                      cart?.cartTotalAmount <= 0 ||
                      !networkAvailableGlobal ||
                      isCancelling ||
                      isCheckingOut ||
                      isPatching
                    }
                    loading={isPatching}
                    fontSize={fs(useWebLayout ? 13 : 12)}
                    opacity={!networkAvailableGlobal ? 0.8 : 1}
                    backgroundColor={theme.colors.primary}
                    rippleColor={theme.colors.primaryDark}
                    height={v(useWebLayout ? 44 : 36)}
                    onPress={handlePatchOrders}
                    paddingHorizontal={s(useWebLayout ? 36 : 24)}
                    borderRadius={theme.borderRadius.md}
                  />

                  {canCheckout && (
                    <Button
                      text={isCheckingOut ? 'Checking out...' : 'Checkout'}
                      fontSize={fs(useWebLayout ? 13 : 12)}
                      disabled={
                        cart?.cartTotalAmount <= 0 ||
                        isCancelling ||
                        isCheckingOut ||
                        isSaving ||
                        isPatching
                      }
                      loading={isCheckingOut}
                      backgroundColor={theme.colors.success}
                      opacity={!networkAvailableGlobal ? 0.8 : 1}
                      rippleColor={theme.colors.successDark}
                      height={v(useWebLayout ? 44 : 36)}
                      paddingHorizontal={s(useWebLayout ? 36 : 24)}
                      borderRadius={theme.borderRadius.md}
                      onPress={handleCheckoutButtonPress}
                    />
                  )}
                </View>
              ) : (
                <View style={styles.Buttongrp}>
                  <Button
                    text={isCancelling ? 'Cancelling...' : 'Cancel'}
                    disabled={isCancelling || isPatching}
                    fontSize={fs(useWebLayout ? 13 : 12)}
                    backgroundColor={theme.colors.error}
                    rippleColor={theme.colors.errorDark}
                    height={v(useWebLayout ? 44 : 36)}
                    paddingHorizontal={s(useWebLayout ? 36 : 24)}
                    borderRadius={theme.borderRadius.md}
                    loading={isCancelling}
                    onPress={() =>
                      Cancel(
                        'Cancel Order ?',
                        'Are you sure you want to cancel this order?',
                      )
                    }
                  />
                  <Button
                    text={
                      isSaving
                        ? 'Saving...'
                        : canCheckout
                          ? 'Pay Later'
                          : 'Send to Cashier'
                    }
                    fontSize={fs(useWebLayout ? 13 : 12)}
                    disabled={
                      cart?.cartTotalAmount <= 0 ||
                      isCancelling ||
                      isSaving ||
                      isCheckingOut ||
                      isPatching
                    }
                    backgroundColor={theme.colors.primary}
                    rippleColor={theme.colors.primaryDark}
                    loading={isSaving}
                    paddingHorizontal={s(useWebLayout ? 36 : 24)}
                    borderRadius={theme.borderRadius.md}
                    height={v(useWebLayout ? 44 : 36)}
                    onPress={() => handleSaveOrder()}
                  />
                  {canCheckout && (
                    <Button
                      text={isCheckingOut ? 'Checking out...' : 'Checkout'}
                      fontSize={fs(useWebLayout ? 13 : 12)}
                      disabled={
                        cart?.cartTotalAmount <= 0 ||
                        isCancelling ||
                        isCheckingOut ||
                        isSaving
                      }
                      loading={isCheckingOut}
                      opacity={!networkAvailableGlobal ? 0.8 : 1}
                      backgroundColor={theme.colors.success}
                      paddingHorizontal={s(useWebLayout ? 36 : 24)}
                      borderRadius={theme.borderRadius.md}
                      rippleColor={theme.colors.successDark}
                      height={v(useWebLayout ? 44 : 36)}
                      onPress={handleCheckoutButtonPress}
                    />
                  )}
                </View>
              )}
            </View>
          </KeyboardStickyView>
        </>
      ) : (
        <View
          style={{
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}>
          <AnimatedLottieView
            source={require('../assets/lottie/emptycart.json')}
            autoPlay
            loop
            style={{
              width: s(300),
              height: v(300),
              marginBottom: v(120),
            }}
          />
          <Text
            style={{
              fontSize: fs(18),
              fontFamily: LatoFonts.regular,
              color: theme.colors.text,
            }}>
            There are no items in the basket
          </Text>
        </View>
      )}
      {visibleName && <NameModal SendOrder={SendOrder} isloading={isSaving} />}
      <PriceEditModal
        visible={isSellingPriceEditVisible}
        onClose={() => setIsSellingPriceEditVisible(false)}
        onSave={handleUpdateSellingPrice}
        currentPrice={sellingPriceEditItem?.price ?? 0}
        itemName={sellingPriceEditItem?.itemname ?? ''}
        priceType={sellingPriceEditItem?.price_type ?? 'item'}
        unitOfMass={sellingPriceEditItem?.unitofmass ?? ''}
      />
    </View>
  );
};

export default Cart;

// Create themed styles function (like other product screens)
const createStyles = (
  theme: any,
  opts: { useWebLayout: boolean; useWidthConstraint: boolean },
) => {
  const { useWebLayout, useWidthConstraint } = opts;
  return StyleSheet.create({
    safeArea: {
      flex: 1,
    },
    container: {
      flex: 1,
      flexDirection: 'column',
      marginHorizontal: s(2),
      backgroundColor: theme.colors.background,
      ...(useWidthConstraint && {
        maxWidth: WEB_MAX_CONTENT_WIDTH,
        alignSelf: 'center',
        width: '100%',
        marginHorizontal: 0,
        paddingHorizontal: s(24),
      }),
    },
    scrollViewContent: {
      flex: 1,
    },
    scrollContainer: {
      flexGrow: 1,
    },
    stickyButtonContainer: {
      backgroundColor: theme.colors.surface,
      paddingHorizontal: s(8),
      paddingVertical: s(10),
      ...(useWidthConstraint && {
        maxWidth: WEB_MAX_CONTENT_WIDTH,
        alignSelf: 'center',
        width: '100%',
        paddingHorizontal: s(24),
      }),
    },
    cartContainer: {},
    box: {
      padding: s(4),
      shadowColor: theme.colors.shadow,
      shadowOffset: { width: 0.5, height: 0.5 },
      shadowRadius: v(1),
      shadowOpacity: 0.35,
      elevation: 1.5,
      borderRadius: theme.borderRadius.sm,
      backgroundColor: theme.colors.surface,
      marginHorizontal: s(4),
      marginBottom: v(10),
      borderWidth: borderWidth(0.25),
      borderColor: theme.colors.border,
    },
    boxWeb: {
      ...(Platform.OS === 'web' ? ({ cursor: 'pointer' } as any) : {}),
    },
    boxHovered: {
      // backgroundColor: 'rgba(0,0,0,0.01)',
    },
    cartTopSection: {
      marginTop: v(5),
    },
    cardheader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    listHeaderRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: s(6),
      marginBottom: v(6),
    },
    listHeaderLeft: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s(8),
    },
    listHeaderText: {
      fontFamily: GTFonts.semibold,
      fontSize: fs(14),
      lineHeight: fs(16),
      color: theme.colors.textGray600,
    },
    listHeaderCount: {
      fontFamily: GTFonts.regular,
      fontSize: fs(12),
      lineHeight: fs(14),
      color: theme.colors.textSecondary,
    },
    imageWrap: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    itemImage: {
      width: s(50),
      height: v(50),
      borderRadius: theme.borderRadius.sm,
      resizeMode: 'cover',
      backgroundColor: theme.colors.surface,
    },
    emptyImagePlaceholder: {
      width: s(50),
      height: v(50),
      borderRadius: theme.borderRadius.sm,
      // borderWidth: borderWidth(0.4),
      // borderColor: theme.colors.borderGray,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.colors.backgroundGray100,
    },
    cardContent: {
      flex: 1,
      minWidth: 0,
      marginLeft: s(8),
      gap: v(2),
    },
    cardTopRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: s(8),
    },
    cardBottomRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: s(8),
    },
    rightSection: {
      alignItems: 'flex-end',
    },
    priceRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s(4),
    },
    editablePriceWrap: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s(4),
    },
    itemname: {
      lineHeight: fs(20),
      fontSize: fs(15),
      fontFamily: GTFonts.semibold,
      color: theme.colors.textGray700,
      flex: 1,
      minWidth: 0,
    },
    metaColumn: {
      flex: 1,
      minWidth: 0,
    },
    categoryText: {
      fontFamily: LatoFonts.base,
      fontSize: fs(13),
      color: theme.colors.textSecondary,
    },
    mass: {
      fontFamily: GTFonts.regular,
      fontSize: fs(18),
      marginLeft: s(5),
      lineHeight: fs(20),
      color: theme.colors.text,
    },
    paidPill: {
      alignSelf: 'flex-start',
      marginTop: v(2),
      backgroundColor: `${theme.colors.success}18`,
      borderRadius: theme.borderRadius.sm,
      paddingHorizontal: s(4),
      paddingVertical: v(2),
    },
    paidPillText: {
      fontSize: fs(10),
      lineHeight: fs(13),
      fontFamily: GTFonts.semibold,
      color: theme.colors.success,
    },
    unpaidPill: {
      alignSelf: 'flex-start',
      marginTop: v(2),
      backgroundColor: `${theme.colors.error}18`,
      borderRadius: theme.borderRadius.sm,
      paddingHorizontal: s(4),
      paddingVertical: v(2),
    },
    unpaidPillText: {
      fontSize: fs(10),
      lineHeight: fs(13),
      fontFamily: GTFonts.semibold,
      color: theme.colors.error,
    },
    qty: {
      fontSize: fs(13),
      fontFamily: GTFonts.bold,
      lineHeight: fs(20),
      color: theme.colors.text,
    },
    subTotal: {
      fontFamily: GTFonts.semibold,
      lineHeight: fs(20),
      color: theme.colors.text,
      fontSize: fs(13),
      flexShrink: 1,
      marginRight: s(8),
    },
    subTotalPrefix: {
      fontSize: fs(13),
      lineHeight: fs(18),
      fontFamily: GTFonts.regular,
      color: theme.colors.textSecondary,
    },
    Total: {
      fontSize: fs(18),
      fontWeight: 'bold',
      fontFamily: GTFonts.regular,
      color: theme.colors.text,
    },
    footer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: s(8),
      backgroundColor: theme.colors.surface,
      borderRadius: isTablet() ? theme.borderRadius.md : theme.borderRadius.sm,
      elevation: 4,
    },
    bottom: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: s(4),
    },
    itemBottom: {
      marginTop: v(2),
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    btnQuantity: {
      gap: useWebLayout ? s(8) : 6,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
    },
    Buttongrp: {
      justifyContent: 'space-around',
      alignItems: 'flex-end',
      flexDirection: 'row',
    },
    trashButton: {
      paddingVertical: s(8),
      paddingHorizontal: s(6),
    },
    centeredView: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: v(22),
    },
    modalView: {
      margin: v(20),
      backgroundColor: theme.colors.surface,
      borderRadius: isTablet() ? theme.borderRadius.md : theme.borderRadius.sm,
      padding: s(35),
      alignItems: 'center',
      shadowColor: theme.colors.shadow,
      shadowOffset: {
        width: 0,
        height: v(2),
      },
      shadowOpacity: 0.25,
      shadowRadius: v(4),
      elevation: 5,
    },
  });
};
